<div class="h-full flex flex-col bg-neutral-3 rounded-2xl p-4">
  <div class="sticky top-0 z-10 bg-neutral-3 py-2 px-6 rounded-2xl">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-4xl font-bold flex items-center gap-2">
        Locations
        @let count = (locationsResource.value() ?? []).length;
        <span class="text-base font-normal text-gray-500">
          ({{ count }} {{ count === 1 ? 'location' : 'locations' }})
        </span>
      </h2>

      <app-add-button label="Add Location" (clicked)="addLocation()" />
    </div>
  </div>

  <div class="flex-1 overflow-auto">
    @if (locationsResource.isLoading()) {
      <div class="p-4 text-center text-gray-500">Loading…</div>
    } @else if ((locationsResource.value() ?? []).length) {
      @for (loc of locationsResource.value() ?? []; track loc.id) {
        <app-location-item [location]="loc" />
      }
    } @else {
      <div class="p-4 text-center text-gray-500">No locations found.</div>
    }
  </div>
</div>
